"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
exports.artifactType = 'receivableResponseTape';
// Zod schema and new types
exports.NodeConfigSchema = zod_1.z
    .object({
    operationDescription: zod_1.z
        .string()
        .describe('Description shown in the operation node'),
    tapeDescription: zod_1.z.string().describe('Description shown in the tape node'),
    useReceivableWaivers: zod_1.z
        .boolean()
        .optional()
        .describe('Whether to apply receivable waivers'),
})
    .describe('Configuration for receivableResponseTape node');
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map